import { render, staticRenderFns } from "./OwnReservationModal.vue?vue&type=template&id=5b344cb2&"
import script from "./OwnReservationModal.vue?vue&type=script&lang=js&"
export * from "./OwnReservationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports